/* eslint-disable default-param-last */
import { SET_LOADING, SET_NAVBAR_VISIBILITY } from "../actions/types";
const initState = {
    loading: false,
    nav_visibility: true,
};
export default function componentStateReducer(state = initState, action) {
    switch (action.type) {
        case SET_LOADING: {
            return {
                ...state,
                loading: action.payload,
            };
        }
        case SET_NAVBAR_VISIBILITY: {
            return {
                ...state,
                nav_visibility: action.payload,
            };
        }
        default:
            return state;
    }
}
